"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVirtualGeolocationStencil = exports.virtualGeolocationStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.virtualGeolocationStencilDefinition = {
    view: {
        label: 'Virtual Geolocation',
        group: 'Misc.',
        titleItems: ['title'],
        contentAreas: [
            {
                name: 'main',
                items: ['title'],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'Settings',
                        items: ['standalone'],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
        ],
    },
    content: {
        [properties_1.propertiesContainerPropertyDefinition.name]: properties_1.propertiesContainerPropertyDefinition,
        [properties_1.standalonePropertyDefinition.name]: properties_1.standalonePropertyDefinition,
        [properties_1.titlePropertyDefinition.name]: properties_1.titlePropertyDefinition,
    },
    localizations: [],
    roles: [],
    spaces: [
        'batalla',
        'brand-building-events',
        'global',
        'illume',
        'organics',
        'organics-mixed-consumption',
        'racing-bulls',
        'rb-juniorteam',
        'rb-rookies',
        'redbull-advancedtechnologies',
        'redbull-racing',
        'redbull-powertrains',
        'redbull_com',
        'redbulletin',
        'redbullmusic',
        'wingfinder',
    ],
    name: 'virtual-geolocation',
};
const isVirtualGeolocationStencil = (stencil) => {
    return stencil.name === exports.virtualGeolocationStencilDefinition.name;
};
exports.isVirtualGeolocationStencil = isVirtualGeolocationStencil;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmlydHVhbC1nZW9sb2NhdGlvbi5zdGVuY2lsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3N0ZW5jaWxzL3ZpcnR1YWwtZ2VvbG9jYXRpb24uc3RlbmNpbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSw4Q0FJc0I7QUFFVCxRQUFBLG1DQUFtQyxHQUFHO0lBQ2pELElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxxQkFBcUI7UUFDNUIsS0FBSyxFQUFFLE9BQU87UUFDZCxVQUFVLEVBQUUsQ0FBQyxPQUFPLENBQUM7UUFDckIsWUFBWSxFQUFFO1lBQ1o7Z0JBQ0UsSUFBSSxFQUFFLE1BQU07Z0JBQ1osS0FBSyxFQUFFLENBQUMsT0FBTyxDQUFDO2FBQ2pCO1lBQ0Q7Z0JBQ0UsSUFBSSxFQUFFLE1BQU07Z0JBQ1osUUFBUSxFQUFFO29CQUNSO3dCQUNFLElBQUksRUFBRSxVQUFVO3dCQUNoQixLQUFLLEVBQUUsQ0FBQyxZQUFZLENBQUM7cUJBQ3RCO29CQUNEO3dCQUNFLElBQUksRUFBRSxtQkFBbUI7d0JBQ3pCLEtBQUssRUFBRSxDQUFDLHNCQUFzQixDQUFDO3FCQUNoQztpQkFDRjthQUNGO1NBQ0Y7S0FDRjtJQUNELE9BQU8sRUFBRTtRQUNQLENBQUMsa0RBQXFDLENBQUMsSUFBSSxDQUFDLEVBQUUsa0RBQXFDO1FBQ25GLENBQUMseUNBQTRCLENBQUMsSUFBSSxDQUFDLEVBQUUseUNBQTRCO1FBQ2pFLENBQUMsb0NBQXVCLENBQUMsSUFBSSxDQUFDLEVBQUUsb0NBQXVCO0tBQ3hEO0lBQ0QsYUFBYSxFQUFFLEVBQUU7SUFDakIsS0FBSyxFQUFFLEVBQUU7SUFDVCxNQUFNLEVBQUU7UUFDTixTQUFTO1FBQ1QsdUJBQXVCO1FBQ3ZCLFFBQVE7UUFDUixRQUFRO1FBQ1IsVUFBVTtRQUNWLDRCQUE0QjtRQUM1QixjQUFjO1FBQ2QsZUFBZTtRQUNmLFlBQVk7UUFDWiw4QkFBOEI7UUFDOUIsZ0JBQWdCO1FBQ2hCLHFCQUFxQjtRQUNyQixhQUFhO1FBQ2IsYUFBYTtRQUNiLGNBQWM7UUFDZCxZQUFZO0tBQ2I7SUFDRCxJQUFJLEVBQUUscUJBQXFCO0NBQ0csQ0FBQTtBQUl6QixNQUFNLDJCQUEyQixHQUFHLENBQUMsT0FBb0IsRUFBd0MsRUFBRTtJQUN4RyxPQUFPLE9BQU8sQ0FBQyxJQUFJLEtBQUssMkNBQW1DLENBQUMsSUFBSSxDQUFBO0FBQ2xFLENBQUMsQ0FBQTtBQUZZLFFBQUEsMkJBQTJCLCtCQUV2QyJ9